import React from 'react';
import Dashboard from './Dashboard';
import {useSelector} from 'react-redux';
import {withPageLayout, WithPageLayoutProps} from '../../hocs';
import {selectSettings} from '../../selectors';

export type DashboardViewProps = WithPageLayoutProps;

const DashboardView: React.FC<DashboardViewProps> = ({affiliateAccount, messages, configState}) => {
    const settingsState = useSelector(selectSettings);

    return (
        <Dashboard
            messages={messages}
            affiliateAccount={affiliateAccount}
            settingsState={settingsState}
            configState={configState}
        />
    );
};

export default withPageLayout(DashboardView);
